<div class="kr-user-card surface">
  <div class="kr-user-card__left">
    <div class="kr-user-card__avatar">
      {{ firstLetter }}
    </div>

    <div class="kr-user-card__user">
      <h4 class="kr-user-card__user-name">
        {{ user().firstName }} {{ user().lastName }}
      </h4>

      <span class="kr-user-card__user-role">
        {{ user().role }}
      </span>
    </div>
  </div>
</div>
